module.exports = __webpack_public_path__ + "img/ico198.41ee5118.svg";